import { marqueeItems } from "../data/content";

// One slow editorial marquee — domain vocabulary drifting quietly.
export default function Marquee() {
  const row = [...marqueeItems, ...marqueeItems];
  return (
    <div className="overflow-hidden border-b border-hairline bg-canvasAlt py-4" aria-hidden="true" data-testid="marquee-strip">
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8 font-mono text-xs uppercase tracking-[0.25em] text-faint">
            {item}
            <span className="w-1 h-1 bg-teal/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
